export default __webpack_public_path__ + "static/media/HeroImage.5cdbe47a.png";